<ul class="social-media">
	<li *ngFor="let socialMedia of socialMediaList" class="social-media-item">
		<a
			[href]="socialMedia.link"
			target="_blank"
			class="social-media-item__circle"
			[style.backgroundColor]="color">
			<i [ngClass]="['bi', socialMedia.icon]"></i>
		</a>
	</li>
</ul>
